import _ from 'lodash'
import React from 'react'
import { Link } from 'react-router-dom'
import { Form } from 'semantic-ui-react'

import { tr } from '../../helpers/languages'

const F = (props) => {
    return (
        <Form autoComplete="new-password">
            <Form.Input
                name='eemail'
                type='text'
                autoComplete="new-password"
                placeholder={tr('EMAIL')}
                error={!_.isEmpty(props.errors) && !_.isEmpty(props.errors.email)}
                onChange={(e) => { props.onChangeValue('email', e.target.value) }}
            />
            {
                !_.isEmpty(props.errors) && !_.isEmpty(props.errors.email) && (
                    <div className='error-message'>{props.errors.email}</div>
                )
            }
            <Form.Input
                name='ppassword'
                type='password'
                autoComplete="new-password"
                placeholder={tr('PASSWORD')}
                error={!_.isEmpty(props.errors) && !_.isEmpty(props.errors.password)}
                onChange={(e) => { props.onChangeValue('password', e.target.value) }}
            />
            {
                !_.isEmpty(props.errors) && !_.isEmpty(props.errors.password) && (
                    <div className='error-message'>{props.errors.password}</div>
                )
            }
            <Form.Button
                type='submit'
                className={props.doNotDisturb ? 'do-not-disturb' : ''}
                onClick={(_e) => { props.onLogIn() }}
            >
                {tr('LOG_IN')}
            </Form.Button>
            <div className='forgot'>
                <span>{tr('FORGOT_PASSWORD')}</span>&nbsp;
                <Link to='/forgot-password'>
                    <span>{tr('RESET_HERE')}</span>
                </Link>
            </div>
        </Form>
    )
}

export default F



// WEBPACK FOOTER //
// ./src/components/login/form.js